import type { CountryCode } from "libphonenumber-js";

import { z } from "zod";

export const phoneLightSchema = z.preprocess((val) => {
  if (typeof val !== "string") return val;
  return val.replace(/[\s-.()]/g, "").trim();
}, z.string().regex(/^\+?[1-9]\d{7,14}$/, { message: "Invalid phone: optional +, 8–15 digits" }));

export const phoneE164Schema = (defaultCountry?: CountryCode): z.ZodTypeAny =>
  z
    .string()
    .trim()
    .refine(
      async (val) => {
        if (!val) return false;
        const { parsePhoneNumberFromString } = await import(
          "libphonenumber-js"
        );
        const pn = parsePhoneNumberFromString(val, defaultCountry);
        return !!pn && pn.isValid();
      },
      { message: "Invalid phone number" }
    )
    .transform(async (val) => {
      const { parsePhoneNumberFromString } = await import("libphonenumber-js");
      const pn = parsePhoneNumberFromString(val, defaultCountry);
      return pn?.number ?? val;
    });

export const phoneE164Optional = (defaultCountry?: CountryCode): z.ZodTypeAny =>
  phoneE164Schema(defaultCountry)
    .optional()
    .transform(async (v) => {
      if (v == null) return undefined;
      if (typeof v === "string" && /^\+?[1-9]\d{7,14}$/.test(v)) return v;
      const { parsePhoneNumberFromString } = await import("libphonenumber-js");
      const pn = parsePhoneNumberFromString(String(v));
      return pn?.number ?? v;
    });
